let collegesCache = null;
let collegesPromise = null;

async function loadUsColleges() {
  if (collegesCache) {
    return collegesCache;
  }

  if (!collegesPromise) {
    collegesPromise = fetch("/data/us-colleges.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to load university list");
        }
        return response.json();
      })
      .then((data) => {
        collegesCache = Array.isArray(data) ? data : [];
        return collegesCache;
      })
      .catch(() => {
        collegesPromise = null;
        collegesCache = [];
        return collegesCache;
      });
  }

  return collegesPromise;
}

export function filterUniversities(colleges, query, limit = 15) {
  const normalizedQuery = String(query || "").trim().toLowerCase();

  if (normalizedQuery.length < 2 || !Array.isArray(colleges)) {
    return [];
  }

  const matches = [];

  for (const college of colleges) {
    if (!college.name.toLowerCase().includes(normalizedQuery)) {
      continue;
    }

    matches.push(college.name);

    if (matches.length >= limit) {
      break;
    }
  }

  return matches;
}

export async function searchUniversitySuggestions(query) {
  const colleges = await loadUsColleges();
  return filterUniversities(colleges, query);
}
